import React from "react";
import { Box, Button, Grid } from "@mui/material";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";

export default function ShellPanel() {
  const table = useMaterialReactTable({
    ...lightTable,
    data: [],
    columns: [
      {
        accessorKey: "c",
        header: "",
        size: 10,
      },
      {
        accessorKey: "Component",
        header: "Component",
        size: 60,
      },
      {
        accessorKey: "Size / Dia",
        header: "Size / Dia",
        size: 60,
      },
      {
        accessorKey: "Length",
        header: "Length",
        size: 60,
      },
      {
        accessorKey: "Thickness",
        header: "Thickness",
        size: 60,
      },
      {
        accessorKey: "Material",
        header: "Material",
        size: 60,
      },
      {
        accessorKey: "Requirements",
        header: "Requirements",
        size: 60,
      },
      {
        accessorKey: "Material Code",
        header: "Material Code",
        size: 60,
      },
      {
        accessorKey: "Material Description",
        header: "Material Description",
        size: 60,
      },
      {
        accessorKey: "Family Table",
        header: "Family Table",
        size: 60,
      },
    ],
  });

  return (
    <>
      <Grid container>
        <Grid item xs={8} sx={{ pt: 2 }}>
          <InputGroupShape name="Shell Details">
            <MaterialReactTable table={table} />
          </InputGroupShape>
        </Grid>
      </Grid>

      <Box sx={{ p: 1 }}>
        <Button sx={{ mr: 1 }} variant="contained">
          Obtain
        </Button>
        <Button sx={{ mr: 1 }} variant="outlined">
          Update Family
        </Button>
        <Button sx={{ mr: 1 }} variant="outlined">
          Update Part
        </Button>
      </Box>
    </>
  );
}
